import React, { useEffect, useState } from 'react';

import Loading from './Loading';
import './css/Preloader.css';

interface PreloaderProps {
    show?: boolean;
}

const Preloader: React.FC<PreloaderProps> = ({ show = true }) => {
    const [showLoading, setShowLoading] = useState(show);

    useEffect(() => {
        (async () => {
            await new Promise((resolve) => setTimeout(resolve, 300));
            setShowLoading(show);
        })();
    }, [show]);

    return (
        <div id="loadingOverlay" className={`loading-overlay ${showLoading ? '' : 'd-none'}`}>
            <Loading message="" />
        </div>
    );
};

export default Preloader;
